import { createTheme } from '@mui/material/styles';


const themes = createTheme({
  palette: {
    primary: {
      light: '#FFFFDE',
      main: '#007235',
      dark: '#007235',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#808080',
      dark: '#007235',
      contrastText: '#000',
    },
    third:{
      light: '#F7FBF2',
      main: '#007235',
      dark: '#007235',
      contrastText: '#000',
      footer: '#F7F7F7'
    },
  }
});

export default themes